import { Locale } from './types';
import { Currency } from './enums';

export const RECENT_SEARCHES_KEY = 'RECENT_SEARCHES_KEY';
export const IS_CHECKIN_TRAVELLERS_DATA_FILLED = ' IS_CHECKIN_TRAVELLERS_DATA_FILLED';
export const SEARCH_FORM_STATE_KEY = 'SEARCH_FORM_STATE_KEY';
export const LOCALE_KEY = 'LOCALE_KEY';
export const CURRENCY_KEY = 'CURRENCY_KEY';
export const SEATS_RECOMMENDATION_SHOWN = 'SEATS_RECOMMENDATION_SHOWN';
export const TEST_AUTHORIZATION_REFUSED = 'TEST_AUTHORIZATION_REFUSED';
export const GRAPHQL_KEY = 'hashed_value';
export const SHOW_RENDERERS_IN_CONSOLE = 'SHOW_RENDERERS_IN_CONSOLE';
export const FOREIGN_PAYMENT_KEY = 'FOREIGN_PAYMENT';
export const SHOW_TRANSLATION_KEYS = 'SHOW_TRANSLATION_KEYS';
export const UTM_MARKS_KEY = 'UTM_MARKS';
export const CUSTOM_SCHEMAS_URL = 'CUSTOM_SCHEMAS_URL';
export const SOCIAL_AUTH_REDIRECT_URL = 'SOCIAL_AUTH_REDIRECT_URL';
export const AUTH_DUPLICATES = 'AUTH_DUPLICATES';
export const IMPORTANT_INSURANCE_TOUCHED = 'IMPORTANT_INSURANCE_TOUCHED';
export const NEW_ACCOUNT_NOTIFICATION = 'NEW_ACCOUNT_NOTIFICATION';
export const SAVE_ORDER_TO_ACCOUNT_SHOWN = 'SAVE_ORDER_TO_ACCOUNT_SHOWN';

export const set = (key: string, value: any, storage = localStorage): void => {
	if (typeof storage !== 'undefined') {
		if (value) {
			try {
				storage.setItem(key, JSON.stringify(value));
			} catch (e) {
				console.warn(e);
			}
		}
	}
};

export const get = <T>(key: string, defaultValue?: T, storage = localStorage): T => {
	let result: T = defaultValue;

	if (typeof storage !== 'undefined') {
		const string = storage.getItem(key);

		if (string) {
			try {
				result = JSON.parse(string);
			} catch (e) {
				console.warn(e);
			}
		}
	}

	return result;
};

export const sessionStorageGet = <T>(key: string, defaultValue?: T): T => {
	return get(key, defaultValue, sessionStorage);
};

export const sessionStorageSet = (key: string, value: any): void => {
	return set(key, value, sessionStorage);
};

export const getShowRenderersInConsole = (): boolean => {
	return !!get<boolean>(SHOW_RENDERERS_IN_CONSOLE);
};

export const getLocaleFromLocalStorage = (): Locale => {
	return get(LOCALE_KEY, window.__webskyEngineConfig?.global?.locale ?? Locale.Russian);
};

export const getShowTranslationKeysFromLocalStorage = () => get<boolean>(SHOW_TRANSLATION_KEYS, false) === true;

export const getCurrency = (): Currency => {
	return get(
		CURRENCY_KEY,
		(window.__webskyEngineConfig?.SearchForm?.selectableCurrencies?.[0]?.code as Currency) || Currency.RUB
	);
};

export const setLocaleToLocalStorage = (locale: Locale): void => {
	set(LOCALE_KEY, locale);
};

export const setCurrency = (currency: Currency): void => {
	const oldCurrency = getCurrency();
	set(CURRENCY_KEY, currency);

	dispatchEvent(new StorageEvent('storage', { key: CURRENCY_KEY, oldValue: oldCurrency, newValue: currency }));
};

export const getIsCheckinTravellersDataFilledFromLocalStorage = (orderId: string) => {
	return get(`${IS_CHECKIN_TRAVELLERS_DATA_FILLED}_${orderId}`);
};

export const setIsCheckinTravellersDataFilledToLocalStorage = (orderId: string, value: boolean) => {
	set(`${IS_CHECKIN_TRAVELLERS_DATA_FILLED}_${orderId}`, value);
};

export const removeFromSessionStorage = (key: string) => {
	sessionStorage.removeItem(key);
};

export const setSessionStorage = (key: string, value: any) => {
	if (typeof sessionStorage !== 'undefined') {
		try {
			sessionStorage.setItem(key, JSON.stringify(value));
		} catch (e) {
			console.warn(e);
		}
	}
};

export const getSessionStorage = <T>(key: string): T => {
	if (typeof sessionStorage !== 'undefined') {
		try {
			const value = sessionStorage.getItem(key);

			return JSON.parse(value);
		} catch (e) {
			return null as T;
		}
	}

	return null;
};
